export const LOCAL_MUTE_ICONS = {
  muteForMe: 'no-sound',
  isolateAudio: 'person-speak-isolate',
  hearEveryone: 'sound',
} as const;
